import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
} from '@material-ui/core';
import useStyles from './style';
import { t } from 'ttag';

const WorkingUnitsTableComponent = ({ site, mode, toggleUnitPower }) => {
  const classes = useStyles();
  const units = site[`onUnits${mode}Arr`] || [];
  const unitCount = site[`onUnits${mode}Count`] || 0;
  if (unitCount === 0) return null;

  return (
    <TableContainer className={classes.tableContainer}>
      <Table
        stickyHeader
        className={classes.table}
        aria-label="customized table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              classes={{ root: classes.tableHeadCell }}
              align="left"
            >
              {t`Units in ${mode} mode`}
            </TableCell>
            <TableCell
              classes={{ root: classes.tableHeadCell }}
              align="right"
            >
              {t`Power`}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {units.map((unit) => {
            const { id, name, canUpdate, isItemOn } = unit;
            const disabled = !canUpdate;

            return (
              <TableRow
                key={id}
                classes={{ root: classes.overWritePaddingRow }}
              >
                <TableCell
                  classes={{ root: classes.overWritePadding }}
                  align="left"
                >
                  {name}
                </TableCell>
                <TableCell
                  classes={{ root: classes.overWritePadding }}
                  align="right"
                >
                  <Switch
                    className={disabled ? classes.switchDisabled : ''}
                    checked={isItemOn}
                    disableRipple={true}
                    onClick={(e) => {
                      if (!disabled) {
                        toggleUnitPower(e, id, !isItemOn);
                      }
                    }}
                    value="checkedA"
                    color="primary"
                    size="medium"
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WorkingUnitsTableComponent;